import { render, staticRenderFns } from "./CardOverLay.vue?vue&type=template&id=20251218"
import script from "./CardOverLay.vue?vue&type=script&lang=js"
export * from "./CardOverLay.vue?vue&type=script&lang=js"
import style0 from "./CardOverLay.vue?vue&type=style&index=0&id=20251218&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports